import React from 'react';

import closeIcon from '@assets/img/icons/close.svg';
import fileIcon from '@assets/img/icons/file-black.svg';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { RemoteFileField } from '@utils/forms';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  buttons: {
    ...common.flexInline,
    justifyContent: 'center',
    marginTop: 27,
  },
  uploadButton: {
    width: 148,
    height: 34,
    borderRadius: 4,
  },
  filesContainer: {
    width: '100%',
  },
  fileItem: {
    ...common.flexInline,
    ...common.flexCenter,
    ...common.middleText,
    background: theme.palette.grey[50],
    padding: '5px 6px',
    marginBottom: 6,
    minWidth: 200,
    '&$downloadable': {
      ...common.baseButton,
    },
  },
  fileName: {
    fontWeight: 500,
    color: theme.palette.grey[800],
    '$downloadable &:hover': {
      color: theme.palette.grey[700],
    },
  },
  fileSize: {
    color: theme.palette.grey[500],
  },
  fileContent: {
    ...common.flexColumn,
    flex: 1,
    marginLeft: 9,
    marginRight: 9,
  },
  fileImg: {
    width: 11,
    height: 14,
  },
  fileDel: {
    width: 10,
    height: 10,
  },
  titleFont: {
    ...common.normalText,
    padding: '20px 0',
  },
  titleTips: {
    ...common.normalText,
    ...common.baseButton,
    color: theme.palette.primary.main,
    marginLeft: 13,
  },
  downloadable: {},
}));

export interface FileItemProps {
  index: number;
  file: RemoteFileField;
  onDelete: () => void;
  readOnly: boolean;
}

export const FileItem: React.FC<FileItemProps> = (props) => {
  const { file, onDelete, readOnly } = props;
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div
      className={clsx(classes.fileItem, file.remote && classes.downloadable)}
      onClick={!file.remote ? undefined : () => window.open(file.remote!)}
    >
      <img className={classes.fileImg} src={fileIcon} alt="file" />
      <div className={classes.fileContent}>
        <div className={classes.fileName}>{file?.file?.name}</div>
      </div>
      {!readOnly ? (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete();
          }}
          className={classes.baseButton}
          style={{ paddingLeft: 20 }}
        >
          <img className={classes.fileDel} src={closeIcon} alt="close" />
        </div>
      ) : null}
    </div>
  );
};

export interface FileArrayDisplayProps {
  files: RemoteFileField[];
  onDelete?: (index: number) => void;
  readOnly?: boolean;
}

export const FileArrayDisplay: React.FC<FileArrayDisplayProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };
  const { files, onDelete = () => {}, readOnly = true } = props;

  return (
    <div className={classes.filesContainer}>
      {files.map((file, index) => (
        <FileItem
          key={index}
          file={file}
          index={index}
          onDelete={() => onDelete(index)}
          readOnly={readOnly}
        />
      ))}
    </div>
  );
};
